import React, { forwardRef } from "react";
import classNames from "classnames/dedupe";
import { mergeDeepLeft } from "ramda";
import { HeartIcon } from "../../../../icons";
import { Button, TButtonProps } from "../Button";
import { noop } from "../../../../helpers";

export interface IHeartButtonProps
  extends Omit<TButtonProps, "variant" | "ref"> {
  /** Toggles icon variant */
  active?: boolean;
  /** Adds animation class */
  isAnimating?: boolean;
  /** Called when css animation ends */
  onAnimationEnd?(): void;
}

const HeartButton = forwardRef<HTMLButtonElement, IHeartButtonProps>(
  ({ active, isAnimating, classes, onAnimationEnd = noop, ...button }, ref) => (
    <Button
      ref={ref}
      variant={active ? "iconHeartActive" : "iconHeart"}
      classes={mergeDeepLeft(
        {
          root: classNames(
            { "uds-zoom-animation": isAnimating },
            classes?.root,
          ),
        },
        classes || {},
      )}
      onAnimationEnd={onAnimationEnd}
      {...button}
    >
      <HeartIcon />
    </Button>
  ),
);

export default HeartButton;
